import React from 'react'
import { CloseIcon, StyledButton, StyledDialog, StyledTypography } from 'shared'

import { BaseModalComponentType } from '../types'
import { withModal } from 'utils/providers/ModalProvider'
import modals from 'constants/modals'
import { Grid, IconButton, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import appRoutes from 'constants/routes'

const InterestFormSuccessModal = ({
  closeModal,
  isOpen,
}: BaseModalComponentType) => {
  const navigate = useNavigate()
  return (
    <StyledDialog open={isOpen} onClose={closeModal}>
      <Grid
        mb={1}
        container
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="nowrap"
      >
        <StyledTypography fontWeight="bold" fontSize="24px">
          Thanks for your interest in this campaign!
        </StyledTypography>
        <IconButton onClick={closeModal}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <Typography mb={1.5}>
        We’ll be in touch in around 2-3 weeks if you’re a good fit for the
        campaign.
      </Typography>
      <Grid container justifyContent="flex-end">
        <StyledButton
          onClick={() => {
            closeModal()
            navigate(appRoutes.campaigns.root)
          }}
          variant="contained"
        >
          Back to Home
        </StyledButton>
      </Grid>
    </StyledDialog>
  )
}

export default withModal(modals.interestFormSuccess)(InterestFormSuccessModal)
